import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "footer" }

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { useGeneralStore } from '@/pinia'
import ButtonOutline from '@/design-system/atoms/buttons/ButtonOutline.vue'
import ButtonPrimary from '@/design-system/atoms/buttons/ButtonPrimary.vue'
import TextFieldStandard from '@/design-system/atoms/TextFieldStandard.vue'
import LayoutOverlay from '@/design-system/templates/LayoutOverlay.vue'
import {
  CreateLinkAttachment,
  postLinkAttachment,
  updateAttachment,
  UpdateLinkAttachment
} from '@/services/attachments.service'
import { useSelectionStore } from '@/pinia/selection'
import { storeToRefs } from 'pinia'
// emits
interface EMITS {
  (e: 'closeEditLinkModal', val: boolean)
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ModalEditLink',
  emits: ["closeEditLinkModal"],
  setup(__props, { emit: __emit }) {

const emits = __emit

// variables
const store = useStore()
const piniaStore = useGeneralStore()
const { t } = useI18n()
const selectionStore = useSelectionStore()
const { clickedEntityType } = storeToRefs(selectionStore)

const currentOverlayModalOnModalPinia = computed(() => {
  return piniaStore.currentOverlayModalOnModalPinia
})
const editMode = computed(() => piniaStore.selectedLink)
const editedLink = ref<CreateLinkAttachment | UpdateLinkAttachment>({
  entityId: editMode.value && piniaStore.selectedLink ? piniaStore.selectedLink.entityId : '',
  name: editMode.value && piniaStore.selectedLink ? piniaStore.selectedLink.name : '',
  url: editMode.value && piniaStore.selectedLink ? piniaStore.selectedLink.url : '',
  entityType: editMode.value && piniaStore.selectedLink ? piniaStore.selectedLink.entityType : ''
})
const isTicketLink = computed(() => {
  return (
    showOverlayModalOnModalPinia.value && currentOverlayModalOnModalPinia.value === 'editTicketLink'
  )
})
const linkName = ref<string>(
  editMode.value && piniaStore.selectedLink ? piniaStore.selectedLink.name : ''
)
const linkUrl = ref<string>(
  editMode.value && piniaStore.selectedLink ? piniaStore.selectedLink.url : ''
)
const namePrefilledText = computed(() => {
  if (editMode.value && piniaStore.selectedLink) return piniaStore.selectedLink.name
  else return ''
})
const selectedObjectId = computed(() => {
  return store.getters.selectedObjectId
})
const selectedTicketId = computed(() => {
  return piniaStore.selectedTicket?.id
})
const showOverlayModalOnModalPinia = computed(() => {
  return piniaStore.showOverlayModalOnModalPinia
})
const urlPrefilledText = computed(() => {
  if (editMode.value && piniaStore.selectedLink) return piniaStore.selectedLink.url
  else return ''
})
// methods
function closeModal() {
  piniaStore.setSelectedLink(null)
  emits('closeEditLinkModal', false)
}
async function saveLink() {
  editedLink.value.name = linkName.value
  editedLink.value.url = linkUrl.value
  if (editedLink.value.name === '') {
    store.commit('setInfoMessage', {
      type: 'error',
      message: t('general__text__missing-name')
    })
    return
  }
  if (editedLink.value.url === '') {
    store.commit('setInfoMessage', {
      type: 'error',
      message: t('general__text__missing-url')
    })
    return
  }
  try {
    let result
    let selectedEntityType
    if (isTicketLink.value) selectedEntityType = 'TICKET'
    else
      selectedEntityType = clickedEntityType.value === 'REGION' ? 'REALM' : clickedEntityType.value

    if (editMode.value && piniaStore.selectedLink)
      result = await updateAttachment(piniaStore.selectedLink.attachmentId, {
        name: editedLink.value.name,
        url: editedLink.value.url,
        entityType: editedLink.value.entityType ?? selectedEntityType
      })
    else
      result = await postLinkAttachment({
        entityId: isTicketLink.value ? selectedTicketId.value : selectedObjectId.value,
        name: editedLink.value.name,
        url: editedLink.value.url,
        entityType: selectedEntityType
      })
    if (result?.data) {
      store.commit('setInfoMessage', {
        type: 'success',
        message: t('general__data__link-saved')
      })
      piniaStore.setLinksUpdated(result.data)
    } else {
      store.commit('setInfoMessage', {
        type: 'error',
        message: `${t('general__text__something-went-wrong-could-not-save-link')}`
      })
    }
  } catch (error) {
    console.error(error)
    store.commit('setInfoMessage', {
      type: 'error',
      message: `${t('general__text__something-went-wrong-could-not-save-link')}`
    })
  }
  closeModal()
}

function updateName(val: string | number) {
  if (typeof val === 'number') val = val.toString()
  linkName.value = val
}
function updateUrl(val: string | number) {
  if (typeof val === 'number') val = val.toString()
  linkUrl.value = val
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LayoutOverlay, {
    class: "modal-edit-link",
    onCloseOverlay: _cache[2] || (_cache[2] = ($event: any) => (closeModal()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(editMode.value
            ? _unref(t)('general__text__change') + ' ' + _unref(t)('general__data__link').toLowerCase()
            : _unref(t)('general__data__link-add-new')), 1),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(TextFieldStandard, {
            error: !linkName.value,
            "error-message": '* ' + _unref(t)('general__text__required-field'),
            hideIconX: true,
            label: _unref(t)('general__text__name') + ' *',
            placeHolderText: 
            namePrefilledText.value.length ? namePrefilledText.value : _unref(t)('general__data__link-add-name')
          ,
            prefilledText: namePrefilledText.value,
            onEmitInput: updateName
          }, null, 8, ["error", "error-message", "label", "placeHolderText", "prefilledText"]),
          _createVNode(TextFieldStandard, {
            error: !linkUrl.value,
            "error-message": '* ' + _unref(t)('general__text__required-field'),
            hideIconX: true,
            label: "URL *",
            placeHolderText: "https://www.example.com",
            prefilledText: urlPrefilledText.value,
            onEmitInput: updateUrl
          }, null, 8, ["error", "error-message", "prefilledText"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ButtonOutline, {
            class: "button",
            buttonText: _unref(t)('general__text__cancel'),
            size: "small",
            onOnClicked: _cache[0] || (_cache[0] = ($event: any) => (closeModal()))
          }, null, 8, ["buttonText"]),
          _createVNode(ButtonPrimary, {
            class: "button",
            buttonText: editMode.value ? _unref(t)('general__data__save-changes') : _unref(t)('general__data__link-add'),
            disabled: 
            !linkName.value.length ||
            !linkUrl.value.length ||
            ((editMode.value && linkName.value === namePrefilledText.value && linkUrl.value === urlPrefilledText.value) ?? false)
          ,
            size: "small",
            onOnClicked: _cache[1] || (_cache[1] = ($event: any) => (saveLink()))
          }, null, 8, ["buttonText", "disabled"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})